import { defineBlock, smartProps } from '@smartfire/js-block-engine';
import { EditableImg } from '@smartfire/components';
import style from './block.module.scss';

function UnderlinedImage() {
    return (
        <>
            <EditableImg smartProp={'image'} className={style.image} />
            <div className={style.underline} />
        </>
    );
}

export default defineBlock({
    Block: UnderlinedImage,
    smartProps: {
        image: smartProps.image,
    },
    setup: {
        title: 'Image soulignée',
        parent: ['smartfire/standard-block-variant---standard-column-variant'],
    },
});
